import { IconBuildingStore, IconDatabase, IconDeviceGamepad2, IconSettings, type Icon } from '@tabler/icons-react';

/**
 * The one thing the descriptor cannot carry: a React component. The marks are the design
 * system's shared glyph vocabulary — the same ones the operator-facing backoffice uses for
 * these concepts — with a neutral fallback for a type this client was never compiled for.
 */
const GLYPHS: Record<string, Icon> = {
    studio: IconBuildingStore,
    game: IconDeviceGamepad2,
    config: IconSettings,
};

export const typeGlyph = (type: string): Icon => GLYPHS[type] ?? IconDatabase;
